<template>
  <div ref="image" class="c-image" @click="$emit('on-select')">
    <div class="c-image-wrap" :class="{ 'c-active-check': active }">
      <div v-if="!!image" class="c-complete">
        <img :src="image" width="100%" height="100%" alt="" />
      </div>
      <div v-else class="c-init">
        <Icon :type="icon" size="28" />
        <span>请添加图片</span>
      </div>
      <div v-show="active" class="c-corn">
        <Button shape="circle" icon="md-arrow-up" @click.stop="$emit('on-prev')" />
        <Button shape="circle" icon="md-arrow-down" @click.stop="$emit('on-next')" />
        <Button shape="circle" icon="md-trash" @click.stop="$emit('on-delete')" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'imageComponent',
  props: {
    attr: {
      type: Array,
      default() {
        return []
      }
    },
    active: {
      type: Boolean,
      default() {
        return false
      }
    },
    icon: {
      type: String
    },
    index: {
      type: Number
    }
  },
  computed: {
    image() {
      let url = ''
      const index = this.attr.findIndex((ret) => ret.name === 'image')
      if (index > -1) url = this.attr[index].image
      return url
    }
  }
}
</script>
<style lang="scss" scoped>
.c-image {
  width: 100%;
  // min-height 201px
  position: relative;

  .c-image-wrap {
    width: 375px;
    // min-height 200px
    margin: 0 auto;
    box-shadow: 1px 1px 7px 1px #e8e8e8;
    position: relative;

    &.c-active-check {
      border: solid 1px #4b77ee;

      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        width: 3840px;
        height: inherit;
        background-color: #e8e9eb;
        left: -1920px;
        top: -1px;
      }

      i,
      span {
        color: #4b77ee;
      }
    }

    .c-init {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #fff;

      span {
        font-size: 14px;
        line-height: 22px;
        margin-top: 4px;
      }
    }

    .c-complete {
      width: 100%;
      // height 100%
    }

    .c-corn {
      width: 32px;
      height: 110px;
      position: absolute;
      z-index: 4;
      top: 45px;
      right: -52px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
